// extracted by mini-css-extract-plugin
module.exports = {"navItemDefault":"Navbar_navItemDefault__3NZ1W","nav":"Navbar_nav__3cHYR","navItemActive":"Navbar_navItemActive__1yNZc"};